import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import FilledCompany from "../../../components/public/SignUp/CompanyProfile/FilledCompany";
import Industry from "../../../components/public/SignUp/CompanyProfile/industry";
import { CompanyAddress } from "../../../components/public/SignUp/CompanyProfile/CompanyAddress";
import { ContactInformation } from "../../../components/public/SignUp/CompanyProfile/ContactInformation";
import { TradeLicense } from "../../../components/public/SignUp/CompanyProfile/TradeLicense";
import { AuthorizedSignatory } from "../../../components/public/SignUp/CompanyProfile/AuthorizedSignatory";
import { AuthorizedLetter } from "../../../components/public/SignUp/CompanyProfile/AuthorizationLetter";
import { LoadingIcon } from "../../../components/common";
import RequestClaimSent from "../../../components/public/SignUp/CompanyProfile/RequestClaimSent";
import { setCompany } from "../../../store/search/searchSlice";
import useCompanyData from "../../../Hooks/useCompanyData";
import { useIndividualCompanyMutation } from "../../../store/Company/companyApiSlice";
import { setUserInfo, clearUserInfo } from "../../../store/auth/authSlice";
import { useGetUserQuery } from "../../../store/auth/usersApiSlice";
import { CommonToast } from "../../../components/common/Toast";
import ReactGA from "react-ga4";


export const ClaimCompany = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const [address, setAddressData] = useState([]);
  const [authSigned, setAuthSignedData] = useState();
  const { worldBoxToken } = useSelector((state) => state.search);
  const { id } = useParams();
  const [individualCompany] = useIndividualCompanyMutation();

  const { token, userInfo } = useSelector((state) => state.auth);
  const { data, isLoading, error } = useCompanyData(id, token, worldBoxToken);
  const { data: userData, refetch, isSuccess, isError } = useGetUserQuery(token);

  useEffect(() => {
    if(isError) {
      CommonToast.error('User not found');
      navigate("/login")
    }
    if (isSuccess) {
      dispatch(setUserInfo({ ...userData }));
    }
  }, [userData, dispatch, isSuccess]);

  // useEffect(() => {
  //   if (userData) {
  //     refetch();
  //   }
  // }, [refetch, userData]);


  useEffect(() => {
    if (data) {
      dispatch(setCompany(data));
    }
  }, [dispatch, data]);

  const handleFilledCompanyNext = () => {
    setStep(5);
  };

  const handleSectorBack = () => {
    ReactGA.event({
      category: 'Claim',
      action: 'Claim Process:Moved back from sector',
      label:`Moved back from sector; "${userInfo?.email?.replace(/@/g, '=')}"`
    });
    setStep(1);
  };

  const handleIndustryNext = () => {
    ReactGA.event({
      category: 'Claim',
      action: 'Claim Process:Filled industry Details',
      label:`Filled industry Details; "${userInfo?.email?.replace(/@/g, '=')}"`
    });
    setStep(3);
  };

  const handleCompanyAddressNext = (addressData) => {
    ReactGA.event({
      category: 'Claim',
      action: 'Claim Process:Filled Company Address Details',
      label:`Filled Company Address Details; "${userInfo?.email?.replace(/@/g, '=')}"`
    });
    setAddressData(addressData);
    setStep(4);
  };

  const handleCompanyAddressBack = () => {
    ReactGA.event({
      category: 'Claim',
      action: 'Claim Process:Moved back from company address',
      label:`Moved back from company address; "${userInfo?.email?.replace(/@/g, '=')}"`
    });
    setStep(2);
  };

  const handleContactInfoNext = () => {
    ReactGA.event({
      category: 'Claim',
      action: 'Claim Process:Filled Company Contact Details',
      label:`Filled Company Contact Details; "${userInfo?.email?.replace(/@/g, '=')}"`
    });
    setStep(5);
  };

  const handleContactInfoPrev = () => {
    ReactGA.event({
      category: 'Claim',
      action: 'Claim Process:Moved back from Contact Details',
      label:`Moved back from Contact Details; "${userInfo?.email?.replace(/@/g, '=')}"`
    });
    setStep(3);
  };

  const handleTradeLicenseNext = () => {
    ReactGA.event({
      category: 'Claim',
      action: 'Claim Process:Filled Company Trade License Details',
      label:`Filled Company Trade License Details; "${userInfo?.email?.replace(/@/g, '=')}"`
    });
    setStep(6);
  };

  const handleTradeBack = () => {
    ReactGA.event({
      category: 'Claim',
      action: 'Claim Process:Moved Back from Company Trade License Details',
      label:`Moved Back from Company Trade License Details; "${userInfo?.email?.replace(/@/g, '=')}"`
    });
    setStep(1);
  };

  const handleAuthorizedSignatoryNext = (authSignedData) => {
    ReactGA.event({
      category: 'Claim',
      action: 'Claim Process:Filled Company Authorized Signatory Details',
      label:`Filled Company Authorized Signatory Details; "${userInfo?.email?.replace(/@/g, '=')}"`
    });
    setAuthSignedData(authSignedData);
    setStep(2);
  };

  const handleAuthorizedSignatoryBack = () => {
    ReactGA.event({
      category: 'Claim',
      action: 'Claim Process:Moved Back from Company Authorized Signatory Details',
      label:`Moved Back from Company Authorized Signatory Details; "${userInfo?.email?.replace(/@/g, '=')}"`
    });
    setStep(5);
  };

  const handleAuthorizedLetterNext = async () => {
    ReactGA.event({
      category: 'Claim',
      action: 'Claim Process:Filled Company Authorized Signatory Letter',
      label:`Filled Company Authorized Signatory Letter; "${userInfo?.email?.replace(/@/g, '=')}"`
    });
    setStep(8);
  };

  const handleAuthorizedLetterBack = () => {
    ReactGA.event({
      category: 'Claim',
      action: 'Claim Process:Moved Back from Company Authorized Signatory Letter',
      label:`Moved Back from Company Authorized Signatory Letter; "${userInfo?.email?.replace(/@/g, '=')}"`
    });
    setStep(6);
  };

  switch (step) {
    case 1:
      return isLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <LoadingIcon />
        </div>
      ) : (
        <FilledCompany
          company={data}
          onNext={handleFilledCompanyNext}
          onPrev={() => navigate(`/search/${id}`)}
        />
      );
    case 2:
      return <Industry onNext={handleIndustryNext} onPrev={handleSectorBack} />;
    case 3:
      return (
        <CompanyAddress
          onNext={handleCompanyAddressNext}
          onPrev={handleCompanyAddressBack}
        />
      );
    case 4:
      return (
        <ContactInformation
          address={address}
          onNext={handleAuthorizedLetterNext}
          onPrev={handleContactInfoPrev}
        />
      );
    case 5:
      return (
        <TradeLicense
          onNext={handleTradeLicenseNext}
          onPrev={handleTradeBack}
        />
      );
    case 6:
      return (
        <AuthorizedSignatory
          onNext={handleAuthorizedSignatoryNext}
          onPrev={handleAuthorizedSignatoryBack}
        />
      );
    case 7:
      return (
        <AuthorizedLetter
          authSigned={authSigned}
          onNext={handleAuthorizedLetterNext}
          onPrev={handleAuthorizedLetterBack}
        />
      );
    case 8:
      return <RequestClaimSent onPrev={() => setStep(7)} />;
    default:
      return null;
  }
};
